/* =================== HEADER FULL =================== */
jQuery(document).ready(function ($) {
  if (!isMobileX(1119)) {
    var header = $(".menu-vertical");
    if (header.length > 0) {
      var toggleHeaderFull = function toggleHeaderFull() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 300) {
          header.addClass("fixed");
        } else {
          header.removeClass("fixed");
        }
      };
      toggleHeaderFull();
      $(window).on("scroll", debounce(function () {
        toggleHeaderFull();
      }, 10));
    }
  }
});
jQuery(window).scroll(function () {
  var $sections = $(".menu-scroll");
  $sections.each(function (i, el) {
    var top = $(el).offset().top - 160;
    var bottom = top + $(el).height();
    var scroll = $(window).scrollTop();
    var id = $(el).attr("id");
    if (scroll > top && scroll < bottom) {
      $("a.active").removeClass("active");
      $('a[href="#' + id + '"]').addClass("active");
    }
  });
});
$("#lista-menu").on("click", "a", function (event) {
  event.preventDefault();
  var id = $(this).attr("href"),
    top = $(id).offset().top;
  $("body,html").animate({
    scrollTop: top
  }, 800);
});
"use strict";

/* =================== HEADER =================== */
$(function () {
  // Ajusta padding-top da body com base na altura do header
  /* function fixBodyTop() {
    if ($(".header").length && $(".header").css("position") === "fixed") {
      const headerHeight = $(".header").outerHeight();
      $("body").css("padding-top", headerHeight);
    }
  }
  $(window).on("resize", debounce(fixBodyTop, 50));
  $(window).on("load", fixBodyTop); */

  // Menu fixo ao rolar a tela
  const $header = $(".header-full");
  if ($header.length > 0) {
    function toggleHeaderFull() {
      const scrollTop = $(window).scrollTop();
      if (scrollTop > 100) {
        $header.addClass("active");
      } else {
        $header.removeClass("active");
      }
    }
    toggleHeaderFull();
    $(window).on(
      "scroll",
      debounce(function () {
        toggleHeaderFull();
      }, 50)
    );
  }
});
